import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import Picker from "react-mobile-picker";
import Popup from "../../Popup/BasePopup";
import Button from "../../CommonFields/Button";

function generateNumberArray(begin, month, year) {
  let array = [];
  let end = 30;

  // Determine the number of days in the month
  if (month === 2) {
    end = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28;
  } else if ([1, 3, 5, 7, 8, 10, 12].includes(month)) {
    end = 31;
  } else {
    end = 30;
  }

  for (let i = begin; i <= end; i++) {
    array.push((i < 10 ? "0" : "") + i);
  }
  return array;
}

function generateArrayOfYears() {
  const min = new Date().getFullYear();
  const max = min + 10;
  const years = [];
  for (let i = min; i <= max; i++) {
    years.push(i);
  }
  return years;
}

function generateMonths() {
  const months = [];
  for (let i = 1; i <= 12; i++) {
    months.push((i < 10 ? "0" : "") + i);
  }
  return months;
}

const DatePicker = ({ cancel, getDate, showDateandTime }) => {
  const today = new Date();
  const tyear = today.getFullYear();
  const tmonth = today.getMonth() + 1; // +1 because months are 0-indexed
  const tday = today.getDate();

  const { t } = useTranslation();
  const [isCancel, setIsCancel] = useState(cancel);
  const [valueGroups, setValueGroups] = useState({
    year: tyear,
    month: ("0" + tmonth).slice(-2),
    day: ("0" + tday).slice(-2),
  });
  const [optionGroups, setOptionGroups] = useState({
    year: generateArrayOfYears(),
    month: generateMonths(),
    day: generateNumberArray(1, tmonth, tyear),
  });
  

  useEffect(() => {
    const { month, year } = valueGroups;

    // Update the days when month or year changes
    const newDays = generateNumberArray(1, parseInt(month), parseInt(year));
    setOptionGroups((prev) => ({
      ...prev,
      day: newDays,
    }));

    // Reset the day if the selected day is not valid for the new month
    if (!newDays.includes(valueGroups.day)) {
      setValueGroups((prev) => ({
        ...prev,
        day: newDays[0], // Set to the first day of the month
      }));
    }
  }, [valueGroups.month, valueGroups.year]);

  useEffect(() => {
    // Reset month to '01' when year changes
    if (valueGroups.year !== tyear) {
      setValueGroups((prev) => ({
        ...prev,
        month: "01", // Reset to January
      }));
    }
  }, [valueGroups.year]);

  const doneHandler = () => {
    const selectedDate = `${valueGroups.day}/${valueGroups.month}/${valueGroups.year}`;
    getDate(selectedDate);
    setIsCancel(false);
  };

  const isCancelHandler = () => {
    setIsCancel(false);
    showDateandTime();
  };

  return (
    <Popup isOpen={true} onClose={isCancelHandler} title={"Select Date"}>
      <Picker value={valueGroups} onChange={setValueGroups} wheel="natural" className="picker-date">
        {Object.keys(optionGroups).map(name => (
          <Picker.Column key={name} name={name} className="option">
            {optionGroups[name].map(option => (
              <Picker.Item key={option} value={option}>
                {option}
              </Picker.Item>
            ))}
          </Picker.Column>
        ))}
      </Picker>
      <div className="doneBtn">
        <Button onClick={doneHandler} text={t('done')} />
      </div>
    </Popup>
  );
};

export default DatePicker;
